"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

//@flow
function isObject(target) {
  return Object.prototype.toString.call(target) === '[object Object]';
}

function flaser(object) {
  var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
  var objectLine = {};

  function find(target) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    for (var key in target) {
      if (!isObject(target[key])) {
        objectLine["".concat(keys.concat(key).join(split))] = target[key];
        continue;
      }

      find(target[key], keys.concat(key));
    }
  }

  find(object);
  return objectLine;
}

var _default = flaser;
exports.default = _default;